import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ssologinFetch } from "./services/Login";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";


// MSAL Configuration
const msalConfig = {
  auth: {
    clientId: "581cad47-e706-430a-ae19-375e15d99437",
    authority:
      "https://login.microsoftonline.com/bfa3dfb0-91d5-4bf7-9a0c-fbf6ff337187",
    redirectUri: "https://godrej.app-assertai.com/home",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// Initialize MSAL instance
const pca = new PublicClientApplication(msalConfig);

// Event Callback to handle successful token acquisition
pca.addEventCallback(async (event) => {
  if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
    const account = event.payload.account;
    const email = account.username;
    const name = account.name;
    const token = account.idToken;
    console.log("Login Details ----> ", { account, email, name });

    try {
      let data = await ssologinFetch({
        ssoToken: token,
      });
      if (data === 200) {
        toast.success("Login Successful");
        setTimeout(() => {
          localStorage.setItem("path", "/home");
          window.location.href = "/home";
        }, 2000);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error during authentication process:", error);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MsalProvider instance={pca}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <App />
            <ToastContainer />
          </Router>
        </PersistGate>
      </Provider>
  </MsalProvider>
);
